<div class="optimization-diagnostic-detail-layout">
  <p-button
    icon="pi pi-arrow-left"
    label="Retour au diagnostic"
    severity="secondary"
    [text]="true"
    (onClick)="back()"
    class="mb-3 inline-block"
  />

  @if ((loading$ | async) && !data) {
    <div class="flex justify-content-center py-6">
      <p-progressSpinner strokeWidth="4" />
    </div>
  }

  @if (data?.affair; as affair) {
    <!-- ===== EN-TÊTE AFFAIRE ===== -->
    <p-card class="mb-3">
      <div class="flex align-items-start gap-3 flex-wrap">
        <div class="flex-1">
          <div class="flex align-items-center gap-2 flex-wrap mb-1">
            <h2 class="m-0">{{ affair.name ?? 'Affaire #' + affair.affairId }}</h2>
            <p-tag
              [value]="affair.label ?? '—'"
              [severity]="reasonSeverity(affair.code)"
            ></p-tag>
          </div>
          @if (affair.groupingName) {
            <div class="text-sm text-color-secondary">
              {{ affair.groupingName }}
            </div>
          }
          <div class="text-xs font-mono text-color-secondary mb-2">
            Affaire #{{ affair.affairId }} · run #{{ data?.runId }}
          </div>

          @if (affair.comment) {
            <div class="mb-2 text-sm">{{ affair.comment }}</div>
          }

          <!-- Adresse copiable pour vérification cartographique -->
          <div class="address-box flex align-items-center gap-2 flex-wrap">
            <i class="pi pi-map-marker text-color-secondary"></i>
            <span class="select-text font-medium">
              {{ affair.mapsQuery ?? '— adresse inconnue —' }}
            </span>
            <p-button
              [icon]="copied ? 'pi pi-check' : 'pi pi-copy'"
              [label]="copied ? 'Copié' : 'Copier'"
              [severity]="copied ? 'success' : 'secondary'"
              [outlined]="true"
              size="small"
              (onClick)="copyMapsQuery()"
            />
            <p-button
              icon="pi pi-map-marker"
              label="Google Maps"
              severity="secondary"
              [outlined]="true"
              size="small"
              (onClick)="openMaps()"
            />
            @if (affair.redirectUrl) {
              <p-button
                icon="pi pi-external-link"
                label="Ouvrir l'affaire"
                severity="secondary"
                [outlined]="true"
                size="small"
                (onClick)="openRedirect()"
              />
            }
          </div>

          <div class="flex gap-4 flex-wrap mt-2 text-xs text-color-secondary">
            @if (affair.latitude != null && affair.longitude != null) {
              <span class="font-mono"
                >{{ affair.latitude }}, {{ affair.longitude }}</span
              >
            }
            @if (affair.planningDeadline) {
              <span>Échéance : {{ affair.planningDeadline | date: 'dd/MM/yy' }}</span>
            }
          </div>
        </div>
      </div>
    </p-card>

    <!-- ===== CHRONOLOGIE DES ÉVÉNEMENTS ===== -->
    <p-card>
      <div class="flex align-items-center gap-2 mb-3">
        <i class="pi pi-history text-xl"></i>
        <h3 class="m-0">Chronologie du diagnostic</h3>
      </div>

      <p-table
        [value]="data?.events || []"
        styleClass="p-datatable-sm p-datatable-striped"
        dataKey="id"
      >
        <ng-template pTemplate="header">
          <tr>
            <th>Étape</th>
            <th>Raison</th>
            <th>Jour scanné</th>
            <th>Cluster</th>
            <th>Détail</th>
          </tr>
        </ng-template>

        <ng-template pTemplate="body" let-event>
          <tr [class.font-semibold]="event.isFinal">
            <td>
              <span class="font-mono text-sm">{{ event.stage }}</span>
              @if (event.isFinal) {
                <p-tag
                  value="dominante"
                  severity="contrast"
                  class="ml-2"
                ></p-tag>
              }
            </td>
            <td>
              <p-tag
                [value]="event.label"
                [severity]="reasonSeverity(event.code)"
              ></p-tag>
            </td>
            <td class="text-sm">
              {{ event.scanDate ? (event.scanDate | date: 'dd/MM/yy') : '—' }}
            </td>
            <td class="text-sm">{{ event.clusterIndex ?? '—' }}</td>
            <td class="text-xs font-mono detail-cell">
              {{ detailString(event) ?? '—' }}
            </td>
          </tr>
        </ng-template>

        <ng-template pTemplate="emptymessage">
          <tr>
            <td colspan="5" class="text-center text-color-secondary py-4">
              <i class="pi pi-inbox mr-2"></i>Aucun événement
            </td>
          </tr>
        </ng-template>
      </p-table>
    </p-card>
  }
</div>
